import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CalendarComponent from "../../../components/calendar";
import AppLoader from "../../../components/loader";
import { AppContext } from "../../../lib/Context";
import { getfollowUpDates } from "../../../services/ContractApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import AppHeader from "../../../components/header/index";
import { useNavigate } from "react-router-dom";
// import {
//   setLeadEndDate,
//   setLeadSaleStatusValue,
//   setLeadSearchValue,
//   setLeadStartDate,
//   setProposalSearchValueForAgent,
// } from "../../../lib/redux/slices/searchKeysSlice";
import { Box } from "@mui/material";
import { setCurrentPage } from "../../../lib/redux/slices/contractPaginateSlice";
import { getAllMeetingDetails } from "../../../services/LeadProposalApi";
import { LEAD_STAGE } from "../../../lib/Variable";

const dropDownStyle = {
  display: "flex",
  overflowY: "auto",
  gap: 0.5,

  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    display: "none",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "primary.main",
    // borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "secondary.dark",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "text.coolGrey",
  },
};

const MeetingCalenderComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [allMeetingDates, setAllMeetingDates] = useState([]);
  const { userData } = useContext(AppContext);

  useEffect(() => {
    getAllMeetingDates();
  }, []);

  const getAllMeetingDates = async () => {
    setIsLoading(true);
    try {
      const response = await getAllMeetingDetails([userData?._id]);


      if (response.data.status === "success") {
        const data = response.data.data;
        const newData = data?.map((x) => {
          const findColorCode = LEAD_STAGE.find((y) => y.value === x.leadStage);
          return ({
            id: x._id,
            title: x.meeterName || "NA",
            businessName: x.businessName || "NA",
            start: new Date(x.setMeeting),
            end: new Date(x.setMeeting),
            meetingDateTime: x.setMeeting,
            username: x.username || "NA",
            contact: x.contact || "NA",
            agentName: x.agentName || "NA",
            address: x.address || "NA",
            note: x.note || "NA",
            allDay: true,
            type: "meeting",
            colorCode: findColorCode?.colorCode || "#C8E6C9",
          })
        });

        setAllMeetingDates(newData);
      } else {
        handleOpenSnackBar(response.data.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  //   const handleSelectMeeting = (data) => {
  //     if (data.type === "lead") {
  //       navigate(`/proposals`);
  //       dispatch(setProposalSearchValueForAgent(data.id));
  //     } else {
  //       navigate(`/all-prospects`);
  //       dispatch(setLeadSearchValue(data.id));
  //       dispatch(setLeadStartDate(""));
  //       dispatch(setLeadEndDate(""));
  //       dispatch(setLeadSaleStatusValue([]));
  //       dispatch(setCurrentPage(1));
  //     }
  //   };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />

      <CalendarComponent
        data={allMeetingDates || []}
        // onSelectEvent={handleSelectMeeting}
        title={"Meeting Dates"}
        dataType="meeting"
      />
    </Box>
  );
};

export default MeetingCalenderComponent;
